"use client";

import { fetchAPI } from "@/utils/fetchData";
import { useState, useEffect } from "react";
import NewsCard from "./newsCard";
import { Media } from "../../../global";
import Button from "../ui/button";

interface NewsItemsProps {
    date: string;
    title: string;
    tag: string;
    image: Media;
    slug: string;
}

export default function NewsItems({ tag }: { tag: string }) {
    const [currentNews, setCurrentNews] = useState([]);
    const [count, setCount] = useState(9);

    const fetchData = async () => {
        const timestamp = new Date().getTime(); // use timestamp to create unique url to resolve caching issues
        const data = await fetchAPI(`/newsitems?_=${timestamp}`, "content");
        setCurrentNews(
            tag !== "All"
                ? data.data
                      .filter((news: NewsItemsProps) => news.tag === tag)
                      .slice(0, count)
                : data.data.slice(0, count)
        );
    };

    const handleButtonClick = () => {
        setCount(count + 3);
    };

    useEffect(() => {
        fetchData();
    }, [tag, count]);

    return (
        <>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 lg:gap-8">
                {currentNews.length > 0 ? (
                    currentNews.map((news: NewsItemsProps, i: number) => (
                        <a
                            className="flex flex-col col-span-1"
                            key={i}
                            href={`/news/${news.slug}`}
                        >
                            <NewsCard
                                title={news.title}
                                date={news.date}
                                tag={news.tag}
                                image={news.image}
                            />
                        </a>
                    ))
                ) : (
                    <div className="w-screen text-4xl ">Coming Soon</div>
                )}
            </div>
            <div
                className={`w-full flex justify-center mt-8 ${
                    count > currentNews.length
                        ? "transition-opacity duration-300 opacity-0"
                        : ""
                }`}
            >
                <Button
                    text="Load More"
                    onClick={handleButtonClick}
                    className=""
                />
            </div>
        </>
    );
}

// const fetchData = async () => {
//     const timestamp = new Date().getTime(); // use timestamp to create unique url to resolve caching issues
//     const queryParams = [
//         count !== null ? `count=${count}` : "",
//         tag !== "All" ? `tag=${tag}` : "",
//         `_=${timestamp}`, // Add the cache-busting parameter
//     ]
//         .filter(Boolean)
//         .join("&"); // Filter out empty strings and join with '&'

//     const data = await fetchAPI(`/newsitems?${queryParams}`, "content");
//     setCurrentNews(data.data);
// };

// const handleButtonClick = () => {
//     setCount(count + 3);
// };

// useEffect(() => {
//     fetchData();
// }, [count, tag]);
